import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSeparator',
})
export class ThousandSeparatorPipe implements PipeTransform {
  transform(value: string | number | null | undefined, minimumFraction: number = 0): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: minimumFraction,
    });

    // Handle null, undefined, or NaN early
    if (value === null || value === undefined) {
      return formatter.format(0);
    }

    let numValue: number;

    if (typeof value === 'number') {
      numValue = value;
    } else {
      numValue = parseFloat(value);
    }

    if (isNaN(numValue)) {
      return formatter.format(0);
    }

    numValue = Math.max(0, Number(numValue.toFixed(minimumFraction)));
    return formatter.format(numValue);
  }
}
